import { createFileRoute } from '@tanstack/react-router';

import { AdminOrgDetailView } from 'src/sections/admin/org-detail/admin-org-detail-view';

export const Route = createFileRoute('/admin-skidog/$orgId/')({
  component: AdminOrgDetailPage,
});

function AdminOrgDetailPage() {
  const { orgId } = Route.useParams();
  return <AdminOrgDetailView organizationId={orgId} />;
}
